<ion-searchbar #searchBar (ionChange)="filterChoices()" placeholder="{{ 'COMPONENTS.searchable_choices.search' | translate }}" ionAutoMode></ion-searchbar>
